module.exports = __webpack_public_path__ + "img/wisa_pc_02.aa2279d6.png";